import script from "./ManutOsViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsViewPage.vue?vue&type=style&index=0&id=5041df58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5041df58"]])

export default __exports__